import React from 'react';

const LoadingSkeleton = () => (
  <div className="poi-details">
    <div className="skeleton-image pulse" />
    
    <div className="btn-container d-flex justify-content-between mx-3 mt-4">
      {[1, 2, 3].map(i => (
        <div key={i} className="skeleton-button pulse" />
      ))}
    </div>

    <div className="container mt-4">
      <div className="skeleton-title pulse" />
      <div className="skeleton-description pulse" />
      {[1, 2, 3].map(i => (
        <div key={i} className="skeleton-line pulse" />
      ))}
    </div>
  </div>
);

export default LoadingSkeleton;